import { AvatarSize } from '@cbhq/cds-common';
import { Avatar } from '@cbhq/cds-web/media';

import type { Member } from '../utils/constants';
import { getDisplayName } from '../utils/helpers';

type MemberAvatarProps = {
  member: Member;
  size?: AvatarSize;
};

export function MemberAvatar({ member, size = 'xl' }: MemberAvatarProps) {
  const displayName = getDisplayName(member);

  return <Avatar name={displayName} alt={displayName} src={member.avatarUrl} size={size} />;
}
